module.exports = __webpack_public_path__ + "img/85.ce6ce8be.jpg";